var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.handleClick}},[_c('i',{directives:[{name:"icon",rawName:"v-icon:folder",arg:"folder"}],staticClass:"flex items-center w-[18px] h-[18px] mt-px text-primary-0"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }